<template>
    <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="20.843" height="19.985" viewBox="0 0 20.843 19.985">
        <path
            id="Caminho_10514"
            data-name="Caminho 10514"
            d="M8.845.659l-2.419,4.9-5.411.789A1.186,1.186,0,0,0,.36,8.374l3.915,3.815-.926,5.389a1.185,1.185,0,0,0,1.719,1.248l4.841-2.544,4.841,2.544a1.185,1.185,0,0,0,1.719-1.248l-.926-5.389,3.915-3.815A1.186,1.186,0,0,0,18.8,6.352L13.39,5.563,10.971.659A1.186,1.186,0,0,0,8.845.659Z"
            transform="translate(0.513 0.501)"
            fill="#ffffff"
            v-bind:class="{'fill-current': (isFill)}"
            class="hover:bg-[#0771c5]"
            stroke="#0771c5"
            stroke-width="1"
            style=""
        />
    </svg>
</template>
<script>
export default {
    props: {
        isFill: Boolean,
        disabled: Boolean,
    }
}
</script>
<style>
    path:hover {
        /* fill: #0771c5; */
    }
</style>
